import { makeStyles } from '@material-ui/core/styles';

export const useFormCreateRequestStyles = makeStyles(theme => ({
  form: {
    flexGrow: 1
  },
  requestTypesContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    columnGap: theme.spacing(3),
    '& > div': {
      flexGrow: 1
    }
  }
}));
